document.addEventListener("DOMContentLoaded", () => {
  // // Template detection - works with any template containing "new"
  // function getNewTemplateClass() {
  //   const bodyClasses = Array.from(document.body.classList);
  //   return bodyClasses.find(className => 
  //     className.includes('template-') && className.includes('new')
  //   );
  // }

  // function hasNewTemplate() {
  //   return !!getNewTemplateClass();
  // }

  // // Only proceed if we have a "new" template
  // if (!hasNewTemplate()) {
  //   return;
  // }

  // const template_name = getNewTemplateClass();
  // console.log(`Carousel dots initialized for: ${template_name}`);

  // Carousel Dots Manager Class
  class CarouselDotsManager {
    constructor() {
      this.currentIndex = 1; // Start at index 1 (second item)
      this.slideCount = 0;
      this.container = null;
      this.wrapper = null;
      this.slides = null;
      this.dotsContainer = null;
      this.observer = null;
      this.intervalId = null;
      
      this.init();
    }

    // Check if required carousel elements exist
    checkRequiredElements() {
      this.container = document.querySelector(".jdgm-carousel__item-container");
      this.wrapper = this.container?.querySelector(".jdgm-carousel__item-wrapper");
      this.slides = this.wrapper?.querySelectorAll(".jdgm-carousel-item");

      if (!this.container || !this.wrapper || !this.slides || this.slides.length === 0) {
        return false;
      }

      // Prevent duplicates
      if (this.container.querySelector(".custom-carousel-dots")) {
        console.log("Carousel dots already exist, skipping initialization");
        return false;
      }

      return true;
    }

    // Wait for carousel to be ready
    waitForCarousel() {
      if (!this.checkRequiredElements()) {
        setTimeout(() => this.waitForCarousel(), 300);
        return;
      }

      this.setupCarousel();
    }

    // Main carousel setup
    setupCarousel() {
      this.slideCount = Math.min(this.slides.length, 13); // Limit to 13 slides (0-12)
      
      this.createDotsContainer();
      this.createDotButtons();
      this.setupEventListeners();
      
      // Initialize carousel to start at second item (index 1)
      setTimeout(() => {
        this.goToSlide(1);
      }, 100);

      // console.log(`Carousel dots created: ${this.slideCount} dots for ${template_name}`);
    }

    // Create the dots container
    createDotsContainer() {
      this.dotsContainer = document.createElement("div");
      this.dotsContainer.className = "custom-carousel-dots";
      Object.assign(this.dotsContainer.style, {
        display: "flex",
        justifyContent: "center",
        gap: "1.2rem",
        marginTop: "5rem",
      });
      this.container.appendChild(this.dotsContainer);
    }

    // Create individual dot buttons
    createDotButtons() {
      for (let i = 0; i < this.slideCount; i++) {
        const btn = document.createElement("button");
        Object.assign(btn.style, {
          width: "1.2rem",
          height: "1.2rem",
          borderRadius: "50%",
          border: "none",
          margin: "0",
          cursor: "pointer",
          backgroundColor: i === 1 ? "#FF5102" : "#D9D9D9", // Highlight index 1
          opacity: i === 1 ? "1" : "0.5", // Highlight index 1
          transition: "all 0.3s ease",
          flex: "0 0 1.2rem",
        });

        btn.addEventListener("click", () => this.goToSlide(i));
        this.dotsContainer.appendChild(btn);
      }
    }

    // Get current slide index from transform
    getCurrentSlideIndex() {
      const computedStyle = getComputedStyle(this.wrapper);
      const transform = computedStyle.transform;

      if (transform === "none" || !transform) return 0;

      // Parse the transform matrix to get translateX value
      const matrix = transform.match(/matrix.*\((.+)\)/);
      if (matrix) {
        const values = matrix[1].split(", ");
        const translateX = parseFloat(values[4]) || 0;
        const slideWidth = this.slides[0].offsetWidth;

        if (slideWidth > 0) {
          const rawIndex = Math.abs(translateX) / slideWidth;
          const index = Math.round(rawIndex);

          // Handle carousel loop - if index is at or beyond slideCount, it might be looping
          if (index >= this.slideCount) {
            // Map higher indices back to the valid range (0-12)
            const mappedIndex = index % this.slideCount;
            return mappedIndex;
          }

          return Math.max(0, Math.min(index, this.slideCount - 1));
        }
      }
      return 0;
    }

    // Update dots appearance
    updateDots(activeIndex) {
      const dots = this.dotsContainer.querySelectorAll("button");
      dots.forEach((dot, i) => {
        if (i === activeIndex) {
          dot.style.opacity = "1";
          dot.style.backgroundColor = "#FF5102";
          dot.style.borderRadius = "10rem";
          dot.style.width = "2.2rem";
          dot.style.flex = "0 0 2.2rem";
        } else {
          dot.style.opacity = "0.5";
          dot.style.backgroundColor = "#D9D9D9";
          dot.style.width = "1.2rem";
          dot.style.flex = "0 0 1.2rem";
        }
      });
    }

    // Go to specific slide
    goToSlide(index) {
      if (index < 0) index = 0;
      else if (index >= this.slideCount) index = this.slideCount - 1;

      // Try to use native carousel dots if they exist
      const nativeDots = this.container.querySelectorAll(".jdgm-carousel__dot");
      if (nativeDots && nativeDots[index]) {
        nativeDots[index].click();
        return;
      }

      // Fallback: set transform directly
      const slideWidth = this.slides[0].offsetWidth;
      const offsetX = -slideWidth * index;
      this.wrapper.style.transform = `translate3d(${offsetX}px, 0px, 0px)`;

      this.currentIndex = index;
      this.updateDots(this.currentIndex);
    }

    // Check for carousel position changes
    checkForChanges() {
      const newIndex = this.getCurrentSlideIndex();
      if (newIndex !== this.currentIndex) {
        this.currentIndex = newIndex;
        this.updateDots(this.currentIndex);
      }
    }

    // Setup all event listeners
    setupEventListeners() {
      // Method 1: MutationObserver on wrapper for style changes
      this.observer = new MutationObserver(() => {
        this.checkForChanges();
      });
      this.observer.observe(this.wrapper, {
        attributes: true,
        attributeFilter: ["style"],
      });

      // Method 2: Periodic checking as backup
      this.intervalId = setInterval(() => this.checkForChanges(), 200);

      // Method 3: Listen for transition events
      this.wrapper.addEventListener("transitionend", () => this.checkForChanges());
      this.wrapper.addEventListener("animationend", () => this.checkForChanges());

      // Method 4: Listen for clicks on any carousel navigation
      this.container.addEventListener("click", (e) => {
        // Small delay to let the carousel update
        setTimeout(() => this.checkForChanges(), 100);
      });
    }

    // Cleanup method
    destroy() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }

      if (this.dotsContainer && this.dotsContainer.parentNode) {
        this.dotsContainer.parentNode.removeChild(this.dotsContainer);
      }

      // console.log(`Carousel dots destroyed for: ${template_name}`);
    }

    // Initialize the carousel
    init() {
      this.waitForCarousel();
    }
  }

  // Initialize carousel dots manager if carousel elements are present
  let carouselDotsManager = null;
  
  // Check if carousel elements exist before initializing
  const carouselExists = document.querySelector(".jdgm-carousel__item-container");
  if (carouselExists) {
    carouselDotsManager = new CarouselDotsManager();
  } else {
    // console.log(`No carousel found for ${template_name}, skipping carousel dots initialization`);
  }

  // Cleanup on page unload
  window.addEventListener("beforeunload", () => {
    if (carouselDotsManager) {
      carouselDotsManager.destroy();
    }
  });
});